import * as React from "react";
import "./TripleNumberInput.component.css";
export function TripleNumberInput({ labels, value, tooltips, tooltipPosition, onChange }) {
    return (React.createElement("section", { className: "triple-number-input-container" },
        React.createElement("div", { className: "triple-number-input-part" },
            React.createElement("span", null, labels[0]),
            React.createElement("input", { type: "number", value: value[0], onChange: (e) => {
                    onChange([parseFloat(e.target.value), value[1], value[2]]);
                }, "data-tooltip": tooltips === null || tooltips === void 0 ? void 0 : tooltips[0], "data-tooltip-position": tooltipPosition })),
        React.createElement("div", { className: "triple-number-input-part" },
            React.createElement("span", null, labels[1]),
            React.createElement("input", { type: "number", value: value[1], onChange: (e) => {
                    onChange([value[0], parseFloat(e.target.value), value[2]]);
                }, "data-tooltip": tooltips === null || tooltips === void 0 ? void 0 : tooltips[1], "data-tooltip-position": tooltipPosition })),
        React.createElement("div", { className: "triple-number-input-part" },
            React.createElement("span", null, labels[2]),
            React.createElement("input", { type: "number", value: value[2], onChange: (e) => {
                    onChange([value[0], value[1], parseFloat(e.target.value)]);
                }, "data-tooltip": tooltips === null || tooltips === void 0 ? void 0 : tooltips[2], "data-tooltip-position": tooltipPosition }))));
}
